/**
 * One definition of an unpaid invoice.
 *
 * kind = invoice, status issued / partial / overdue, remaining balance > 0.
 * Credit notes are never outstanding. The same rule is the SQL view
 * public.outstanding_invoices (migration 20261108130000).
 *
 * Call sites: Forside (DashboardWidgets), Fakturaer cards (invoiceKpis),
 * Til betaling (payment_queue, built from that view), Kasse outstanding
 * (useCashierReport, same rule and only invoices issued in the period).
 */

export const OUTSTANDING_INVOICE_STATUSES = ['issued', 'partial', 'overdue'] as const;

export type OutstandingInvoiceStatus = (typeof OUTSTANDING_INVOICE_STATUSES)[number];

export function outstandingRemainingCents(totalCents: number, paidCents: number): number {
  return Math.max(0, (Number(totalCents) || 0) - (Number(paidCents) || 0));
}

export function isOutstandingInvoice(input: {
  kind?: string | null;
  status: string;
  totalCents: number;
  paidCents?: number | null;
}): boolean {
  if (input.kind === 'credit_note') return false;
  if (input.kind != null && input.kind !== 'invoice') return false;
  if (!(OUTSTANDING_INVOICE_STATUSES as readonly string[]).includes(input.status)) return false;
  return outstandingRemainingCents(input.totalCents, input.paidCents ?? 0) > 0;
}
